import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ConfirmationModalComponent } from '../../../../shared/components/confirmation-modal/confirmation-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { PageHeaderComponent } from '../../../../shared/components/page-header/page-header.component';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton/skeleton.component';
import { SwitchButtonComponent } from '../../../../shared/components/switch-button/switch-button.component';
import { DEFAULT_FILTER } from '../../../../shared/constants/constants';
import { UserRoles } from '../../../../shared/enums/enums';
import { FilterModel } from '../../../../shared/interface/interface';
import { UserModel } from '../../../../shared/models/user.model';
import { UserService } from '../../../../shared/services/user.service';
import { SharedModule } from '../../../../shared/shared.module';
import { AddEditUserComponent } from '../add-edit-user/add-edit-user.component';

@Component({
  selector: 'app-users',
  standalone: true,
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
  imports: [
    AddEditUserComponent,
    ModalComponent,
    SharedModule,
    ConfirmationModalComponent,
    SkeletonLoaderComponent,
    PageHeaderComponent,
    ButtonComponent,
    ButtonLoaderComponent,
    SwitchButtonComponent,
  ],
})
export class UsersComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;
  users: UserModel[] = [];
  statusUpdateUserId: string = '';
  statusUpdateLoading: boolean = false;

  subscription: Subscription = new Subscription();
  private userFilterSubject$: BehaviorSubject<FilterModel> =
    new BehaviorSubject<FilterModel>(DEFAULT_FILTER);
  userFilter = this.userFilterSubject$.asObservable();
  totalUser = 0;
  userRoles = UserRoles;
  prevStatus: boolean = false;
  constructor(
    private userService: UserService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.subscribeToFilter();
  }

  getUserList(filter: FilterModel) {
    this.isLoading = true;
    this.userService.fetchUserList(filter).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.users =
          filter.pageNumber > 1 ? [...this.users, ...res.result] : res.result;
        this.totalUser = res.count;
      },
      error: (err: any) => {
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
        this.isLoading = false;
      },
    });
  }

  deleteUser() {
    this.statusUpdateLoading = true;
    this.userService.deleteUser(this.statusUpdateUserId).subscribe({
      next: (res) => {
        this.statusUpdateLoading = false;
        this.toastr.success('User deactivated successfully !!');
        this.closeStatusUpdateModal();
        this.updateUserFilter({ ...DEFAULT_FILTER });
      },
      error: (err: any) => {
        this.statusUpdateLoading = false;
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
      },
    });
  }
  closeStatusUpdateModal() {
    this.statusUpdateUserId = '';
    this.prevStatus = false;
  }

  onUserStatusUpdate(id: string, status: boolean) {
    this.statusUpdateUserId = id;
    this.prevStatus = status;
  }

  updateUserFilter(filter: FilterModel) {
    this.userFilterSubject$.next(filter);
  }

  subscribeToFilter() {
    const sub = this.userFilterSubject$.subscribe((value) => {
      this.getUserList(value);
    });
    this.subscription.add(sub);
  }

  loadMoreIfLastIndex() {
    const { searchText, pageNumber, limit } = this.userFilterSubject$.value;
    if (pageNumber * limit < this.totalUser) {
      this.updateUserFilter({ searchText, limit, pageNumber: pageNumber + 1 });
    }
  }
  hnadleSearch(searchText: string) {
    if (searchText.length === 0 || searchText?.trim()) {
      this.updateUserFilter({
        ...this.userFilterSubject$.value,
        pageNumber: 1,
        searchText: searchText,
      });
    }
  }
  activateUser() {
    this.statusUpdateLoading = true;
    this.userService.activateUser(this.statusUpdateUserId).subscribe({
      next: (res) => {
        this.updateUserFilter({ ...DEFAULT_FILTER });
        this.closeStatusUpdateModal();
        this.statusUpdateLoading = false;
        this.toastr.success('User activated successfully !!');
      },
      error: (err) => {
        this.statusUpdateLoading = false;
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
      },
    });
  }

  handleToggleClick(user: UserModel) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
